/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Task_Reminders_Status_LabelInputs */

const en_task_reminders_status_label = /** @type {(inputs: Task_Reminders_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "pending") return /** @type {LocalizedString} */ (`Pending`);
	if (i?.status === "sent") return /** @type {LocalizedString} */ (`Sent`);
	if (i?.status === "not_sent") return /** @type {LocalizedString} */ (`Not sent`);
	if (i?.status === "canceled") return /** @type {LocalizedString} */ (`Canceled`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_task_reminders_status_label = /** @type {(inputs: Task_Reminders_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "pending") return /** @type {LocalizedString} */ (`Pendente`);
	if (i?.status === "sent") return /** @type {LocalizedString} */ (`Enviado`);
	if (i?.status === "not_sent") return /** @type {LocalizedString} */ (`Não enviado`);
	if (i?.status === "canceled") return /** @type {LocalizedString} */ (`Cancelado`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "pending" | "Pending" |
* | "sent" | "Sent" |
* | "not_sent" | "Not sent" |
* | "canceled" | "Canceled" |
* | * | "{status}" |
*
* @param {Task_Reminders_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_status_label = /** @type {((inputs: Task_Reminders_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_status_label(inputs)
	return pt_br2_task_reminders_status_label(inputs)
});